import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Skeleton } from "@mui/material";
import LearnTextEmbed from "../LearnPanelComponents/LearnCopy/LearnTextEmbed";

type OverviewIntroProps = {
  loading: boolean;
};

function OverviewIntro(props: OverviewIntroProps) {
  return (
    <Box
      sx={{
        flexGrow: 0,
        sizing: "border-box",
        maxWidth: "1250px",
      }}
    >
      <Typography variant="h4" color="info.main">
        {props.loading ? (
          <Skeleton variant="text" width="50%" height="100%" />
        ) : (
          "View the evolution of your value - past, present, and future (4 min)"
        )}
      </Typography>
      <Typography variant="h5" color="text.secondary">
        {props.loading ? (
          <Skeleton variant="text" width="100%" height="100%" />
        ) : (
          <>
            <LearnTextEmbed content="Get the big picture overview about how your equity-based compensation evolves over time" />
            <br />
            <LearnTextEmbed
              content="Click the button to tell us a bit about your stock plans. You can often find this information in your offer
            letter, annual compensation letter, or company brokerage portal (AI-automated upload coming soon!). If you
            have any questions or trouble finding this information, please reach out to us at contact@usesalus.com for
            help!"
            />
          </>
        )}
      </Typography>
    </Box>
  );
}

export default OverviewIntro;
